import { create } from "zustand";

interface ApprovalStore {
    amount?: number;
    tokenId?: string;
    allowance?: bigint;
    isCheckingAllowance: boolean;
    isApproving: boolean;
    reset: () => void;
    set: (args: Partial<ApprovalStore>) => void;
    setAmount: (amount: number) => void;
    setTokenId: (tokenId: string) => void;
    setAllowance: (allowance?: bigint) => void;
    setIsCheckingAllowance: (isChecking: boolean) => void;
    setIsApproving: (isApproving: boolean) => void;
}

const defaultState = {
    amount: undefined,
    tokenId: undefined,
    allowance: undefined,
    isCheckingAllowance: false,
    isApproving: false,
};

export const useApprovalStore = create<ApprovalStore>((set) => ({
    ...defaultState,
    set: ({ ...args }: Partial<ApprovalStore>) => set(args),
    setAmount: (amount: number) => set({ amount }),
    setTokenId: (tokenId: string) => set({ tokenId }),
    setAllowance: (allowance?: bigint) => set({ allowance }),
    setIsCheckingAllowance: (isChecking: boolean) => set({ isCheckingAllowance: isChecking }),
    setIsApproving: (isApproving: boolean) => set({ isApproving }),
    reset: () => set(defaultState),
}));
